import type { ReactNode } from "react";

export function AuthLayout({
  icon,
  title,
  description,
  children,
  footer,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-surface-subtle px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-700 text-white">
            {icon}
          </div>
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-700">
            Shalom App Control
          </p>
          <h1 className="mt-1 text-lg font-semibold text-ink">{title}</h1>
          {description && <p className="mt-1 text-sm text-ink-muted">{description}</p>}
        </div>
        <div className="rounded-xl border border-ink/10 bg-white p-6 shadow-card">{children}</div>
        {footer && <div className="mt-4 text-center text-sm text-ink-muted">{footer}</div>}
      </div>
    </div>
  );
}
